<template src="./index.html"></template>

<script>
	import {
		getdata
	} from './data.js';
	import {
		queryVoucherInfo,
		getNextVoucherId,
		getBeforeVoucherId,
		unPostVoucher,
		getNewErpNo,
		saveOrUpdateVoucher,
		postingofAccount,
		postVoucher
	} from '../../../../api/home.js';
	import config from '../../../../../configHttp';
	import axios from 'axios'
	export default {
		name: 'PreviewVoucher',
		data() {
			return {
				id: '',
				headerJson: {
					pingzh: '', //凭证号
					xitpzh: '', //系统凭证号
					pingzrq: '', // 凭证日期
					cain: '', // 凭证年度
					qij: '', // 凭证期间
					pingzlx: '1', // 凭证类型
					fuzpzh: '', // 辅助凭证号
					guozzt: '', // 过账状态
					kuaijzg: '', //  会计主管
					fuhr: '', // 复核人
					zhidr: '' // 制单人
				},
				//表格数据
				detailJson: [{
					yuanpzzy1: '', //摘要
					zhongfkm: '', //中方科目科目代码
					zhongfkmms: '', //中方科目科目描述
					benb: '', //币种金额币种
					benbjfje: '', //币种金额借方金额
					benbdfje: '', //币种金额贷方金额
					erpkm: '', //外方科目科目代码
					erpkmms: '', //外方科目科目描述
					yuanbz: '', //原币种金额币种
					yuanjfje: '', //原币种金额借方金额
					yuandfje: '', //原币种金额贷方金额
					fenxdms: {}, //分析代码
					cankzds: {} //参考字段
				}],
				hjbenbdfje: 0.0,
				hjbenbjfje: 0.0,
				indexsupplement: 0,
				tableData1: [{}],
				list: [{}, {}, {}, {}, {}, {}, {}, {}],
				value: '',
				choosedjindex: null,
				visibleSrc: "",
				fileData: [{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					},
					{
						label: '参考附件1.zip'
					}
				]
			};
		},
		mounted() {},
		activated() {
			this.InitializeJiem();
		},
		created() {

			this.id = this.$route.query.id;
			this.InitializeJiem();

		},
		methods: {
			forPrint() {
				this.getvisibleSrc()
			},
			//过账
			postingofAccount() {
				let params = {};
				params.id = this.id;
				postVoucher(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('过账成功');
						this.InitializeJiem();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			Jumptwo(index, zhongfkm) {
				if (zhongfkm != '') {
					this.$router.push({
						path: '/GLView',
						query: {
							id: this.id,
							zhongfkm: zhongfkm,
							cain: this.headerJson.cain
						}
					});
				}
			},
			duplication() {
				//获取当前生成的ERP凭证号
				getNewErpNo().then(res => {
					let paramss = {};
					let header = JSON.parse(JSON.stringify(this.headerJson));
					header.pingzh = res.data.data;
					paramss.headerJson = JSON.stringify(header);
					paramss.detailJson = [];
					this.detailJson.forEach(v => {
						if (v.zhongfkm != '') {
							paramss.detailJson.push(v);
						}
					});
					paramss.detailJson = JSON.stringify(paramss.detailJson);
					saveOrUpdateVoucher(paramss).then(res => {
						if (res.data.code == '200') {
							this.$message.success('复制成功');
							this.$router.push('/VoucherQuery');
						} else {
							this.$message.error(res.data.message);
						}
					});
				});
			},
			//下载凭证PDF
			PDFDownload() {
				let req = {
					downUrl: config.baseURL + '/fvm/voucher/voucherPDFDownload?id=' + this.id,
					typeObj: {
						toForm: false,
						fileType: 'pdf',
						fileName: this.headerJson.pingzh
					}
				};
				this.$downloadcommon(req);
			},
			ReversePosting() {
				if (this.headerJson.guozzt != '1') {
					this.$message.error('只有已过账的数据能进行反过账！');
					return;
				}
				let params = {};
				params.id = this.id;
				unPostVoucher(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('反过账成功');
						this.InitializeJiem();
					} else {
						this.$message.error(res.data.message);
					}
				});
			},
			//上一张
			LastPicture() {
				let params = {};
				params.id = this.id;
				getBeforeVoucherId(params).then(res => {
					if (res.data.data != '-1') {
						this.$router.push({
							path: '/PreviewVoucher',
							query: {
								id: res.data.data
							}
						});
					} else {
						this.$message.error('已是最后一张');
					}
				});
			},
			//下一张
			nextPage() {
				let params = {};
				params.id = this.id;
				getNextVoucherId(params).then(res => {
					if (res.data.data != '-1') {
						this.$router.push({
							path: '/PreviewVoucher',
							query: {
								id: res.data.data
							}
						});
					} else {
						this.$message.error('已是最后一张');
					}
				});
			},
			getvisibleSrc() {
				const loading = this.$loading({
				         lock: true,
				         text: 'Loading',
				         spinner: 'el-icon-loading',
				         background: 'rgba(0, 0, 0, 0.7)'
				       });
				axios({
					method: "get",
					url: config.baseURL + '/fvm/voucher/voucherPrint?id=' + this.id + "&qiybh=" + this.headerJson
						.qiybh + "&khbh=" + this.headerJson.khbh,
					headers: {
						"token": localStorage.getItem('token')
					},
					data: '',
					responseType: "blob"
				}).then((res) => {
					var blob = new Blob([res.data], {
						type: 'application/pdf'
					});
					this.visibleSrc = window.URL.createObjectURL(blob)
					let iframe = document.getElementById('appointmentDetailPrintIframe')
					setTimeout(() => {
						loading.close();
						iframe.contentWindow.focus()
						iframe.contentWindow.print()
						window.URL.revokeObjectURL(blob);
					}, 300)
				})
			},
			InitializeJiem() {
				let params = {};
				params.id = this.id;
				queryVoucherInfo(params).then(res => {
					if (res.data.code == '200') {
						this.headerJson = res.data.data.header;
						this.headerJson.pingzrq = this.formatDate(this.headerJson.pingzrq);
						this.detailJson = res.data.data.details;
						let extent = 6 - this.detailJson.length;
						if (extent > 0) {
							for (var i = 0; i < extent; i++) {
								this.detailJson.push({
									yuanpzzy1: '', //摘要
									zhongfkm: '', //中方科目科目代码
									zhongfkmms: '', //中方科目科目描述
									benb: '', //币种金额币种
									benbjfje: '', //币种金额借方金额
									benbdfje: '', //币种金额贷方金额
									erpkm: '', //外方科目科目代码
									erpkmms: '', //外方科目科目描述
									yuanbz: '', //原币种金额币种
									yuanjfje: '', //原币种金额借方金额
									yuandfje: '', //原币种金额贷方金额
									fenxdms: {}, //分析代码
									cankzds: {} //参考字段
								});
							}
						}
						this.hjbenbdfje = 0.0;
						this.hjbenbjfje = 0.0;
						for (var i = 0; i < this.detailJson.length; i++) {
							this.hjbenbdfje += this.getNumber(this.detailJson[i].benbdfje);
						}
						for (var i = 0; i < this.detailJson.length; i++) {
							this.hjbenbjfje += this.getNumber(this.detailJson[i].benbjfje);
						}
					}
				});
			},
			formatDate(value) {
				// 时间戳转换日期格式方法
				if (value == null) {
					return '';
				} else {
					const date = new Date(value);
					const y = date.getFullYear(); // 年
					let MM = date.getMonth() + 1; // 月
					MM = MM < 10 ? '0' + MM : MM;
					let d = date.getDate(); // 日
					d = d < 10 ? '0' + d : d;
					return y + '-' + MM + '-' + d;
				}
			},
			forchoosemove(index) {},
			supplementary(index) {
				if (this.detailJson[index].zhongfkm != '') {
					this.indexsupplement = index;
				}
			},
			forback() {
				this.$router.push('/VoucherQuery');
			},
			getNumber(str) {
				if (str == '') {
					return 0;
				}
				return Number(str);
			}
		}
	};
</script>

<style scoped lang="less">
	@import url('./index.less');
</style>